<template>
    <v-card>
        <v-card-title>
            <div>
                {{ $t('event.notifications') }}<br /><small>{{ "Time Zone: " + THIS_PAGE_TIME_ZONE }}</small>
            </div>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="initAddNotification">
                {{$t('add')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-data-table 
            :headers="headers"
            :items="notificationItems"
            :loading="isNotificationPending"
        >
            <template v-slot:item.scheduledAt="{value}">
                {{(value) ? DateTime.fromISO(value, {zone: THIS_PAGE_TIME_ZONE}).toFormat('yyyy-MM-dd HH:mm') : 'N/A'}}
            </template>
            <template v-slot:item.sentAt="{value}">
                {{(value) ? DateTime.fromISO(value, {zone: THIS_PAGE_TIME_ZONE}).toFormat('yyyy-MM-dd HH:mm') : 'N/A'}}
            </template>
            <template v-slot:item.notificationGroupId="{value}">
                {{ getNGroupName(value) }}
            </template>
            <template v-slot:item.createdAt="{value}">
                {{DateTime.fromISO(value, {zone: THIS_PAGE_TIME_ZONE}).toFormat('yyyy-MM-dd HH:mm')}}
            </template>
            <template v-slot:item.actions="{item}">
                <v-btn v-if="(!item.sentAt) && eventId !== 'not-in-use-now'" color="primary" class="ma-2"
                        @click="initEditNotification(item)">
                    {{$t('edit')}}
                    <v-icon right>mdi-pencil</v-icon>
                </v-btn>
                <v-btn color="red" dark class="ma-2"
                       @click="deleteNotification(item)">
                    {{$t('delete')}}
                    <v-icon right>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>
        <v-dialog 
            v-model="editNotificationDialogShown"
            max-width="600px"
            persistent
            scrollable
        >
            <v-card>
                <v-card-title>
                    {{$t('event.notification')}}
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form v-model="isEditNotificationFormValid" ref="form">
                            <v-row>
                                <v-col class="pb-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('event_notification.type')"
                                        :placeholder="$t('event_notification.type')"
                                        v-model="editingNotification.type"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('event_notification.type') + ' SC'"
                                        :placeholder="$t('event_notification.type') + ' SC'"
                                        v-model="editingNotification.type__sc"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('event_notification.type') + ' TC'"
                                        :placeholder="$t('event_notification.type') + ' TC'"
                                        v-model="editingNotification.type__tc"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        ref="titleRef"
                                        outlined
                                        :label="$t('event_notification.title')"
                                        :placeholder="$t('event_notification.title')"
                                        :rules="required.title"
                                        v-model="editingNotification.title"
                                        @input="contentRef.validate()"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        ref="contentRef" 
                                        outlined
                                        :label="$t('event_notification.content')"
                                        :placeholder="$t('event_notification.content')"
                                        :rules="required.content"
                                        v-model="editingNotification.content"
                                        @input="titleRef.validate()"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        ref="titleRef"
                                        outlined
                                        :label="$t('event_notification.title') + ' SC'"
                                        :placeholder="$t('event_notification.title') + ' SC'"
                                        v-model="editingNotification.title__sc"
                                        @input="contentRef.validate()"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        ref="contentRef" 
                                        outlined
                                        :label="$t('event_notification.content') + ' SC'"
                                        :placeholder="$t('event_notification.content') + ' SC'"
                                        v-model="editingNotification.content__sc"
                                        @input="titleRef.validate()"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        ref="titleRef"
                                        outlined
                                        :label="$t('event_notification.title') + ' TC'"
                                        :placeholder="$t('event_notification.title') + ' TC'"
                                        v-model="editingNotification.title__tc"
                                        @input="contentRef.validate()"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        ref="contentRef" 
                                        outlined
                                        :label="$t('event_notification.content') + ' TC'"
                                        :placeholder="$t('event_notification.content') + ' TC'"
                                        v-model="editingNotification.content__tc"
                                        @input="titleRef.validate()"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        ref="titleRef"
                                        outlined
                                        :label="$t('event_notification.title') + ' ID'"
                                        :placeholder="$t('event_notification.title') + ' ID'"
                                        v-model="editingNotification.title__id"
                                        @input="contentRef.validate()"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        ref="contentRef" 
                                        outlined
                                        :label="$t('event_notification.content') + ' ID'"
                                        :placeholder="$t('event_notification.content') + ' ID'"
                                        v-model="editingNotification.content__id"
                                        @input="titleRef.validate()"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        ref="titleRef"
                                        outlined
                                        :label="$t('event_notification.title') + ' VN'"
                                        :placeholder="$t('event_notification.title') + ' VN'"
                                        v-model="editingNotification.title__vn"
                                        @input="contentRef.validate()"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        ref="contentRef" 
                                        outlined
                                        :label="$t('event_notification.content') + ' VN'"
                                        :placeholder="$t('event_notification.content') + ' VN'"
                                        v-model="editingNotification.content__vn"
                                        @input="titleRef.validate()"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        ref="titleRef"
                                        outlined
                                        :label="$t('event_notification.title') + ' FR'"
                                        :placeholder="$t('event_notification.title') + ' FR'"
                                        v-model="editingNotification.title__fr"
                                        @input="contentRef.validate()"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        ref="contentRef" 
                                        outlined
                                        :label="$t('event_notification.content') + ' FR'"
                                        :placeholder="$t('event_notification.content') + ' FR'"
                                        v-model="editingNotification.content__fr"
                                        @input="titleRef.validate()"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row v-if="eventId !== 'not-in-use-now'">
                                <v-col class="py-0">
                                    <v-select
                                        v-model="selectedNGroup"
                                        :items="nGroupItems"
                                        item-text="name"
                                        :label="$t('event_notification.notification_group')"
                                        :hint="`${$t('Number of guests in group')}: ${(selectedNGroup && selectedNGroup.event_guests && selectedNGroup.event_guests.length) ? selectedNGroup.event_guests.length : 0}`"
                                        :rules="required.group"
                                        persistent-hint
                                        outlined
                                        return-object
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <div>
                                        <v-label 
                                            >{{$t('event_notification.scheduled_at')}}
                                        </v-label>
                                    </div>
                                    <VueCtkDateTimePicker
                                        v-model="tempScheduledDateTime"
                                        :error="DTError"
                                        format="YYYY-MM-DD HH:mm"
                                    />
                                </v-col>
                            </v-row>
                            <v-row v-if="eventId === 'not-in-use-now'">
                                <v-col class="pt-8 pb-0">
                                    <v-file-input
                                        outlined
                                        prepend-icon=""
                                        prepend-inner-icon="$file"
                                        accept=".xlsx, .xls, .csv"
                                        label="Import Guest List"
                                        placeholder="Click to Select..."
                                        :messages="excelUploadStatus"
                                        @click:clear="cancelUploadExcel"
                                        v-model="selectedExcelFile"
                                        @change="uploadExcel"
                                        :rules="[!!selectedExcelFile || 'You must upload a file.']"
                                    >
                                    </v-file-input>
                                </v-col>
                            </v-row>
                            <v-row v-if="eventId === 'not-in-use-now' && stage >= 1">
                                <v-col class="pb-0">
                                    Field Mapping
                                </v-col>
                            </v-row>
                            <v-row v-if="eventId === 'not-in-use-now' && stage >= 1">
                                <v-col>
                                    <v-select
                                    v-model="selectedExcelHeader"
                                    :items="excelHeaders"
                                    item-text="text"
                                    item-value="value"
                                    label="Field in Excel"
                                    outlined
                                    hide-details
                                    ></v-select>
                                </v-col>
                                <v-col>
                                    <v-select
                                    v-model="selectedGuestHeader"
                                    :items="availableGuestHeaders"
                                    item-text="text"
                                    item-value="value"
                                    label="Field in Guest"
                                    outlined
                                    hide-details
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row v-if="eventId === 'not-in-use-now' && stage >= 2">
                                <v-col class="pb-0">
                                    Preview: The below guests will receive this notification
                                </v-col>
                            </v-row>
                            <v-row v-if="eventId === 'not-in-use-now' && stage >= 2">
                                <v-col>
                                    <v-data-table
                                    :headers="previewHeaders"
                                    :items="currentNotificationArray"
                                    ></v-data-table>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" @click="confirmCancelItemDialogShown = true">{{$t('cancel')}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="submit">{{$t('save')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <PopupAlert
            v-model="confirmCancelItemDialogShown"
            title="Warning"
            message="Do you wish to cancel your amendments?"
            :onYes="cancelEditNotification"
            :onNo="function(){confirmCancelItemDialogShown = false;}">
        </PopupAlert>
        <PopupAlert
            v-model="confirmSaveItemDialogShown"
            title="Confirm"
            message="Do you wish to confirm to send your notification?"
            :onYes="saveNotification"
            :onNo="function(){confirmSaveItemDialogShown = false;}">
        </PopupAlert>
        <v-overlay z-index="999" :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-card>
</template>
<style scoped>
    .notificationTimePicker{
        padding: 0px 13px;
    }
</style>
<script>
    import {computed, ref, watch} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
    import PopupAlert from "../../components/PopupAlert";
    import eConfig from "../../evention-config";
    import XLSX from 'xlsx';
    import axios from 'axios';

    export default {
        name: 'EventNotificationList',
        components:{VueCtkDateTimePicker,PopupAlert},
        setup(props, {root}) {
            const THIS_PAGE_TIME_ZONE = 'Asia/Hong_Kong';
            const overlay = ref(false);
            const eventId = computed(() => root.$route.params.eventId);
            const {EventNotification, EventNotificationGroup} = root.$FeathersVuex.api;

            const notificationParams = computed(() => {
                return {
                    query: {
                        eventId: eventId.value,
                        $sort: {scheduledAt: -1},
                    }
                }
            });
            const {items: notificationItems, isPending: isNotificationPending} = useFind({
                model: EventNotification,
                params: notificationParams,
            });

            const fetchNGroupParams = computed(()=>{
                return {
                    query: {
                        eventId: eventId.value,
                        $sort: {name: 1},
                    }
                }
            });
            const {items: nGroupItems, isPending: isNGroupPending} = useFind({
                model: EventNotificationGroup,
                params: fetchNGroupParams,
            });

            // Data Table
            const headers = ref(
                eventId.value === 'not-in-use-now' ? [
                    {text: root.$t('event_notification.scheduled_at'), value: 'scheduledAt'},
                    {text: root.$t('event_notification.sent_at'), value: 'sentAt'},
                    {text: root.$t('event_notification.title'), value: 'title'},
                    {text: root.$t('event_notification.content'), value: 'content'},
                    {text: root.$t('event_notification.created_at'), value: 'createdAt'},
                    {text: '', value: 'actions'},
                ]
                :
                [
                    {text: root.$t('event_notification.scheduled_at'), value: 'scheduledAt'},
                    {text: root.$t('event_notification.sent_at'), value: 'sentAt'},
                    {text: root.$t('event_notification.title'), value: 'title'},
                    {text: root.$t('event_notification.content'), value: 'content'},
                    {text: root.$t('event_notification.notification_group'), value: 'notificationGroupId'},
                    {text: root.$t('event_notification.created_at'), value: 'createdAt'},
                    {text: '', value: 'actions'},
                ]
            );

            // Add / Edit Notification
            const editNotificationDialogShown = ref(false);
            const isEditNotificationFormValid = ref(false);
            const confirmCancelItemDialogShown = ref(false);
            const confirmSaveItemDialogShown = ref(false);
            const form = ref(null);

            const editingNotification = ref(new EventNotification({eventId: eventId.value}));
            const selectedNGroup = ref(null);
            const tempScheduledDateTime = ref("");

            const initAddNotification = function () {
                editingNotification.value = new EventNotification({eventId: eventId.value}); 
                selectedNGroup.value = null;
                tempScheduledDateTime.value = "";
                editNotificationDialogShown.value = true;
            };
            const initEditNotification = function (notification) {
                editingNotification.value = notification;
                selectedNGroup.value = nGroupItems.value.filter((ng)=>ng.id==notification.notificationGroupId)[0];
                
                if (notification.scheduledAt) {
                    const dateTime = DateTime.fromISO(notification.scheduledAt, {zone: THIS_PAGE_TIME_ZONE});
                    const date = dateTime.toFormat('yyyy-MM-dd');
                    const time = dateTime.toFormat('HH:mm');
                    tempScheduledDateTime.value = date + " " + time                    
                } else {
                    tempScheduledDateTime.value = "";
                }
                editNotificationDialogShown.value = true;
            };
            const deleteNotification = function (notification) {
                if (confirm(root.$t('event_notification.confirm_delete'))) {
                    notification.remove().then(() => {
                    }, root.$handleFeatherError.bind(root));
                }
            };
            const saveNotification = async function () {
                overlay.value = true;
                if(tempScheduledDateTime.value=="" || tempScheduledDateTime.value == null){
                    root.$store.dispatch('showSnackBar', root.$t('event_notification.dateTimeNotNull'));
                    return;
                }
                if (eventId.value === 'not-in-use-now') {
                    // create new notification group
                    const newNotificationGroup = new EventNotificationGroup({eventId: eventId.value});
                    newNotificationGroup.name = crypto.randomUUID();
                    await newNotificationGroup.save().then(() => {
                        editingNotification.value.notificationGroupId = newNotificationGroup.id;
                    }, root.$handleFeatherError.bind(root));
                    // import guest to this notification group
                    const prefixUrl = process.env.VUE_APP_SERVER_ADDRESS;
                    await axios.create({
                        headers: {'Authorization': window.localStorage.getItem('feathers-jwt')}
                    }).post(`${prefixUrl}/batch-update-api/batch-update`, {
                        service: 'active-notification-groups',
                        instances: currentNotificationArray.value.map((e) => {
                            return {notificationGroupId: newNotificationGroup.id, eventGuestId: e.eventGuestId}
                        }),
                        operation: 'create'
                    });
                } else {
                    editingNotification.value.notificationGroupId = selectedNGroup.value.id;
                }
                editingNotification.value.scheduledAt = DateTime.fromFormat(`${tempScheduledDateTime.value}`, 'yyyy-MM-dd HH:mm', {zone: THIS_PAGE_TIME_ZONE}).toISO();
                await editingNotification.value.save().then(() => {
                    EventNotification.get(editingNotification.value.id);
                    if (eventId.value === 'not-in-use-now') {
                        cancelUploadExcel();
                    }
                    editNotificationDialogShown.value = false;
                    root.$store.dispatch('showSnackBar', root.$t('event_notification.save_successful'));
                }, root.$handleFeatherError.bind(root));
                confirmSaveItemDialogShown.value = false;
                overlay.value = false;
            };
            const cancelEditNotification = function(){
                cancelUploadExcel();
                editNotificationDialogShown.value = false;
                confirmCancelItemDialogShown.value = false;
            }


            const getNGroupName = function(nGroupId) {
                const temp = nGroupItems.value.filter((obj)=>obj.id == nGroupId);
                return (temp[0]) ? temp[0].name : '';
            }


            const titleRef = ref(null);
            const contentRef = ref(null);
            const required = ref({});
            const DTError = ref(false);

            watch(editNotificationDialogShown, (newVal, oldVal) => {
                if ((!oldVal && newVal)) {
                    required.value = {};
                    form.value.resetValidation();
                    DTError.value = false;
                }
            })

            watch(tempScheduledDateTime, (newVal, oldVal) => {
                if (!oldVal && newVal) {
                    DTError.value = false;
                    return;
                }
            })

            const title = computed(() => editingNotification.value.title);
            const content = computed(() => editingNotification.value.content);
            const group = computed(() => selectedNGroup.value);

            watch([title, content, group], () => {
                if (title.value) {
                    required.value.title = [];
                }
                if (content.value) {
                    required.value.content = [];
                }
                if (group.value) {
                    required.value.group = [];
                }
            })

            const submit = () => {
                required.value = {
                    title: [value => !!value || 'This field is required'],
                    content: [value => !!value || 'This field is required'],
                    group: [value => !!value || 'This field is required']
                }
                if (!tempScheduledDateTime.value) {
                    DTError.value = true;
                }
                if (eventId.value !== 'not-in-use-now') {
                    if (form.value.validate() && title.value && content.value && group.value && tempScheduledDateTime.value) {
                        confirmSaveItemDialogShown.value = true;
                    }
                } else {
                    if (form.value.validate() && title.value && content.value && tempScheduledDateTime.value) {
                        confirmSaveItemDialogShown.value = true;
                    }
                }
            }

            const selectedExcelFile = ref(null);
            const excelHeaders = ref([]);
            const excelData = ref([]);
            const excelUploading = ref(false);
            const excelUploadStatus = ref("Please upload an Excel file");
            const guestList = ref([]);
            const stage = ref(0);
            const currentNotificationArray = ref([]);
            const animationInterval = ref(null);
            watch(excelUploading, (val) => {
                if (val) {
                    let i = 1;
                    animationInterval.value = setInterval(() => {
                        excelUploadStatus.value = "Processing" + ".".repeat(i);
                        i++;
                        if (i > 3) i = 1;
                    }, 1000);
                } else {
                    clearInterval(animationInterval.value);
                }
            });
            const readXLSX = (file) => {
                let nameSplit = file.name.split(".");
                let format = nameSplit[nameSplit.length - 1];
                if (!["xls", "xlsx", "csv"].includes(format)) {
                    return false;
                }
                return new Promise((resolve, reject) => {
                    let reader = new FileReader();
                    reader.readAsArrayBuffer(file);

                    reader.onerror = () => {
                        reject(new Error("Failed to read file"));
                    };

                    reader.onload = function(evt) {
                        try {
                            let data = evt.target.result;
                            var workbook = XLSX.read(data, { type: "array" });
                            let outdata = XLSX.utils.sheet_to_json(
                                workbook.Sheets[workbook.SheetNames[0]],
                                { defval: "" }
                            );
                            resolve(outdata);
                        } catch (error) {
                            reject(new Error("Failed to parse Excel file: " + error.message));
                        }
                    };
                });
            };
            const uploadExcel = async (f) => {
                if (f) {
                    try {
                        excelUploading.value = true;

                        const outdata = await readXLSX(f);
                        excelData.value = outdata;

                        if (excelData.value && excelData.value.length >= 1) {
                            excelHeaders.value = Object.keys(excelData.value[0]).map((col) => {
                                return { text: col, value: col };
                            });
                        }

                        // preload guest data
                        const { EventGuest } = root.$FeathersVuex.api;
                        const { data: guestItems } = await EventGuest.find({
                            query: {
                                eventId: eventId.value,
                                $sort: {
                                    ev_firstname: 1,
                                    ev_lastname: 1,
                                },
                            },
                        });
                        guestList.value = guestItems;

                        // clear stage 2 data
                        selectedGuestHeader.value = 'ev_email';
                        currentNotificationArray.value = [];

                        // guess excel header
                        selectedExcelHeader.value = null;
                        for (let header of excelHeaders.value) {
                            if (['email', 'e-mail', 'ev_email'].includes(header.text.toLowerCase())) {
                                selectedExcelHeader.value = header.value;
                                break;
                            }
                        }

                        await root.$nextTick();

                        if (selectedGuestHeader.value && selectedExcelHeader.value) {
                            stage.value = 2;
                        } else {
                            stage.value = 1;
                        }

                        excelUploading.value = false;
                        excelUploadStatus.value = "Uploaded";
                    } catch (error) {
                        root.$store.dispatch("showSnackBar", error.message);
                    }
                } else {
                    return false;
                }
            };

            const cancelUploadExcel = async function() {
                // clear stage 1 data
                selectedExcelFile.value = null;
                excelHeaders.value = [];
                excelData.value = [];
                excelUploading.value = false;
                excelUploadStatus.value = "Please upload an Excel file";
                guestList.value = [];
                // clear stage 2 data
                selectedGuestHeader.value = 'ev_email';
                selectedExcelHeader.value = null;
                currentNotificationArray.value = [];
                // reset stage
                await root.$nextTick();
                stage.value = 0;
            };

            // stage 2
            // handle excel mapping
            const selectedGuestHeader = ref('ev_email');
            const selectedExcelHeader = ref(null);
            const availableGuestHeaders = computed(() => {
            return Object.entries(eConfig.ev_guest.dbColMapping).map(
                ([key, value]) => {
                return { text: key, value: value };
                }
            );
            });

            watch([selectedGuestHeader, selectedExcelHeader], () => {
                if (selectedGuestHeader.value && selectedExcelHeader.value) {
                    stage.value = 2;
                    currentNotificationArray.value = [];
                    excelData.value.forEach((row) => {
                        guestList.value.forEach((guest) => {
                            if (row[selectedExcelHeader.value] == guest[selectedGuestHeader.value]) {
                                currentNotificationArray.value.push({
                                    eventId: eventId.value,
                                    eventGuestId: guest.id,
                                    eventGuestEmail: guest.ev_email,
                                    eventGuestFirstName: guest.ev_firstname,
                                    eventGuestLastName: guest.ev_lastname,
                                    eventGuestAgencyId: guest.ev_agencyid
                                });
                            }
                        });
                    });
                    // remove duplicates
                    currentNotificationArray.value = [...new Map(currentNotificationArray.value.map(item => [item.eventGuestId, item])).values()];
                }
            });

            const previewHeaders = ref(
                [
                    { text: "Email", value: "eventGuestEmail" },
                    { text: "First Name", value: "eventGuestFirstName" },
                    { text: "Last Name", value: "eventGuestLastName" },
                    { text: "Agency ID", value: "eventGuestAgencyId" }
                ]
            );

            return {
                eventId,
                excelUploading,
                excelUploadStatus,
                cancelUploadExcel,
                uploadExcel,
                selectedExcelFile,
                excelHeaders,
                excelData,
                guestList,
                selectedGuestHeader,
                selectedExcelHeader,
                availableGuestHeaders,
                stage,
                previewHeaders,

                currentNotificationArray,

                notificationItems,
                isNotificationPending,
                nGroupItems,

                selectedNGroup,

                THIS_PAGE_TIME_ZONE,
                headers,

                editNotificationDialogShown,
                confirmCancelItemDialogShown,
                confirmSaveItemDialogShown,

                initAddNotification,
                initEditNotification,
                deleteNotification,
                editingNotification,
                saveNotification,
                cancelEditNotification,
                

                isEditNotificationFormValid,
                tempScheduledDateTime,
                titleRef,
                contentRef,
                required,
                submit,
                DTError,
                form,


                DateTime,
                getFileUrl: root.$getFileURL,
                overlay,

                getNGroupName,
            }
        }
    }
</script>
